// Core
import React from 'react';
// Material ui
import Typography from '@material-ui/core/Typography';
import { useTitleBlockStyle } from "./titleBlock.style";
var TitleBlock = function (_a) {
    var title = _a.title, description = _a.description;
    var classes = useTitleBlockStyle();
    return (React.createElement("div", { className: classes.root },
        description
            ? React.createElement(Typography, { variant: "h1", align: "center" }, title)
            : undefined,
        description
            ? React.createElement(Typography, { align: "center", variant: "h2", dangerouslySetInnerHTML: { __html: description } })
            : undefined));
};
export default TitleBlock;
//# sourceMappingURL=TitleBlock.js.map